import { api } from "@/lib/api/client";
import type { TeachingDirectoryTerm } from "@/lib/api/teachingCourses";

export interface LearningDirectoryCourse {
  course_id: string;
  code: string;
  title: string;
  title_ar: string | null;
  crn: string | null;
  status: "published";
  term: TeachingDirectoryTerm | null;
  enrollment: {
    id: string;
    status: "enrolled" | "complete" | "incomplete";
    participation_kind: "credit" | "audit";
  };
  instructor_name: string | null;
  href: string | null;
}

export interface LearningCourseDirectory {
  projection_version: "learning-courses-v1";
  generated_at: string;
  shell_base: "/student";
  courses: LearningDirectoryCourse[];
}

export const learningCoursesApi = {
  list: () => api.get<LearningCourseDirectory>("/workspaces/learning/courses"),
};
